

export const chatdetail = state => state.chat.chatdetail
export const chatlist = state => state.chat.queues
export const tickets = state => state.chat.tickets
export const messages = state => state.chat.messages
export const chatHistory = state => state.chat.history
export const historymessages = state => state.chat.historymessages